import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1a1ade80 from 'nuxt_plugin_plugin_1a1ade80' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_0a73659a from 'nuxt_plugin_sentryserver_0a73659a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_b68c17dc from 'nuxt_plugin_sentryclient_b68c17dc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_aa4729a4 from 'nuxt_plugin_plugin_aa4729a4' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_vue2editor_4fbcde9e from 'nuxt_plugin_vue2editor_4fbcde9e' // Source: ./vue2-editor.js (mode: 'client')
import nuxt_plugin_vuesocialsharingplugin_86826062 from 'nuxt_plugin_vuesocialsharingplugin_86826062' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_nuxtvuexlocalstorage_3f2f237e from 'nuxt_plugin_nuxtvuexlocalstorage_3f2f237e' // Source: ./nuxt-vuex-localstorage.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_08bb0f7e from 'nuxt_plugin_cookieuniversalnuxt_08bb0f7e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_nuxtcookiecontrol_7fbd38e4 from 'nuxt_plugin_nuxtcookiecontrol_7fbd38e4' // Source: ./nuxt-cookie-control.js (mode: 'all')
import nuxt_plugin_googlegtag_01de5bf6 from 'nuxt_plugin_googlegtag_01de5bf6' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_clipboard_5b6ee436 from 'nuxt_plugin_clipboard_5b6ee436' // Source: ./clipboard.js (mode: 'client')
import nuxt_plugin_vuescrollto_2e4a4d73 from 'nuxt_plugin_vuescrollto_2e4a4d73' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_pluginclient_2f3dfc3c from 'nuxt_plugin_pluginclient_2f3dfc3c' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_d6112478 from 'nuxt_plugin_pluginserver_d6112478' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_workbox_e3be991c from 'nuxt_plugin_workbox_e3be991c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_0f906885 from 'nuxt_plugin_metaplugin_0f906885' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_14380df9 from 'nuxt_plugin_iconplugin_14380df9' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_62d7dbd6 from 'nuxt_plugin_axios_62d7dbd6' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_fontawesome_821a12d0 from 'nuxt_plugin_fontawesome_821a12d0' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_projectStateclient_5a01bbcc from 'nuxt_plugin_projectStateclient_5a01bbcc' // Source: ../plugins/projectState.client.js (mode: 'client')
import nuxt_plugin_vueVideoBackgroundclient_7985cb92 from 'nuxt_plugin_vueVideoBackgroundclient_7985cb92' // Source: ../plugins/vueVideoBackground.client.js (mode: 'client')
import nuxt_plugin_tezosclient_72c01735 from 'nuxt_plugin_tezosclient_72c01735' // Source: ../plugins/tezos.client.js (mode: 'client')
import nuxt_plugin_vuetour_f3e3d3bc from 'nuxt_plugin_vuetour_f3e3d3bc' // Source: ../plugins/vue-tour.js (mode: 'all')
import nuxt_plugin_vuesanitize_51df4e1e from 'nuxt_plugin_vuesanitize_51df4e1e' // Source: ../plugins/vue-sanitize.js (mode: 'all')
import nuxt_plugin_globals_57393abd from 'nuxt_plugin_globals_57393abd' // Source: ../plugins/globals.js (mode: 'all')
import nuxt_plugin_auth_97540acc from 'nuxt_plugin_auth_97540acc' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s","title":"ArtForge — Generative NFTs on Tezos","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"ArtForge is an all-in-one NFT platform offering services to create and mint NFT collections including generative features, crowdsales, and a marketplace."},{"name":"format-detection","content":"telephone=no"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fartforge.io\u002F"},{"hid":"og:title","property":"og:title","content":"ArtForge — Generative NFTs on Tezos"},{"hid":"og:description","property":"og:description","content":"ArtForge is an all-in-one NFT platform offering services to create and mint NFT collections including generative features, crowdsales, and a marketplace."},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fnfty.mypinata.cloud\u002Fipfs\u002FQmZVMZXx737hLvmx2FE49ZExuAH9pW7C5zwiwycnZAYMNU"},{"hid":"twitter:card","property":"twitter:card","content":"summary_large_image"},{"hid":"twitter:url","property":"twitter:url","content":"https:\u002F\u002Fartforge.io\u002F"},{"hid":"twitter:domain","property":"twitter:domain","content":"artforge.io"},{"hid":"twitter:title","property":"twitter:title","content":"ArtForge — Generative NFTs on Tezos"},{"hid":"twitter:description","property":"twitter:description","content":"ArtForge is an all-in-one NFT platform offering services to create and mint NFT collections including generative features, crowdsales, and a marketplace."},{"hid":"twitter:image","property":"twitter:image","content":"https:\u002F\u002Fnfty.mypinata.cloud\u002Fipfs\u002FQmZVMZXx737hLvmx2FE49ZExuAH9pW7C5zwiwycnZAYMNU"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"},{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto:wght@100&family=Inter&family=Josefin+Sans&family=Lato:wght@100;300&display=swap"}],"script":[{"hid":"script","defer":true,"innerHTML":"\u003C!-- Twitter universal website tag code --\u003E\n        !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);\n        },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='\u002F\u002Fstatic.ads-twitter.com\u002Fuwt.js',\n        a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');\n        \u002F\u002F Insert Twitter Pixel ID and Standard Event data below\n        twq('init','o7kwv');\n        twq('track','PageView');\n        \u003C!-- End Twitter universal website tag code --\u003E"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-Q05FJ77ZCX","async":true},{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto:wght@100&family=Inter&family=Josefin+Sans&family=Lato:wght@100;300&display=swap\";document.querySelector(\"head\").appendChild(l);})();"}],"__dangerouslyDisableSanitizers":["script"],"style":[],"noscript":[{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto:wght@100&family=Inter&family=Josefin+Sans&family=Lato:wght@100;300&display=swap\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1a1ade80 === 'function') {
    await nuxt_plugin_plugin_1a1ade80(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_0a73659a === 'function') {
    await nuxt_plugin_sentryserver_0a73659a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_b68c17dc === 'function') {
    await nuxt_plugin_sentryclient_b68c17dc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_aa4729a4 === 'function') {
    await nuxt_plugin_plugin_aa4729a4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2editor_4fbcde9e === 'function') {
    await nuxt_plugin_vue2editor_4fbcde9e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_86826062 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_86826062(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtvuexlocalstorage_3f2f237e === 'function') {
    await nuxt_plugin_nuxtvuexlocalstorage_3f2f237e(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_08bb0f7e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_08bb0f7e(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtcookiecontrol_7fbd38e4 === 'function') {
    await nuxt_plugin_nuxtcookiecontrol_7fbd38e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegtag_01de5bf6 === 'function') {
    await nuxt_plugin_googlegtag_01de5bf6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboard_5b6ee436 === 'function') {
    await nuxt_plugin_clipboard_5b6ee436(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_2e4a4d73 === 'function') {
    await nuxt_plugin_vuescrollto_2e4a4d73(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_2f3dfc3c === 'function') {
    await nuxt_plugin_pluginclient_2f3dfc3c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_d6112478 === 'function') {
    await nuxt_plugin_pluginserver_d6112478(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_e3be991c === 'function') {
    await nuxt_plugin_workbox_e3be991c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_0f906885 === 'function') {
    await nuxt_plugin_metaplugin_0f906885(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_14380df9 === 'function') {
    await nuxt_plugin_iconplugin_14380df9(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_62d7dbd6 === 'function') {
    await nuxt_plugin_axios_62d7dbd6(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_821a12d0 === 'function') {
    await nuxt_plugin_fontawesome_821a12d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_projectStateclient_5a01bbcc === 'function') {
    await nuxt_plugin_projectStateclient_5a01bbcc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueVideoBackgroundclient_7985cb92 === 'function') {
    await nuxt_plugin_vueVideoBackgroundclient_7985cb92(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tezosclient_72c01735 === 'function') {
    await nuxt_plugin_tezosclient_72c01735(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetour_f3e3d3bc === 'function') {
    await nuxt_plugin_vuetour_f3e3d3bc(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesanitize_51df4e1e === 'function') {
    await nuxt_plugin_vuesanitize_51df4e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_globals_57393abd === 'function') {
    await nuxt_plugin_globals_57393abd(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_97540acc === 'function') {
    await nuxt_plugin_auth_97540acc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
